const BASE_ROUTE = "/health-insurance";
export const PRODUCT_LISTING_PAGE_ROUTE = `${BASE_ROUTE}/products-list/`;
